import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import {  useNavigate, useParams } from 'react-router-dom';
import { current, getOneUser, updateProfil, updateUser } from '../Redux/Actions/AuthActions';

const UpdateProfil = () => {



    const dispatch =useDispatch()

    useEffect(()=>{

      dispatch(current())

    },[])

    const user = useSelector(state => state.AuthReducer.user);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    
    useEffect(() => {
      if (user) {
        setName(user.name || '');
        setEmail(user.email || '');
      }
    }, [user]);

    const navigate = useNavigate()

    const handleUpdate=(a)=>{
      a.preventDefault()
      dispatch(updateProfil(user._id,{name,email},navigate))
    }

  return (
    <Form>

    <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control value={name}  onChange ={(e) => setName(e.target.value)} type="name" placeholder="Enter Name" />
        </Form.Group>
    
        <Form.Group className="mb-3">
          <Form.Label>Email Adress</Form.Label>
          <Form.Control value={email}  onChange ={(e) => setEmail(e.target.value)} type="email" placeholder="Enter email" />
        </Form.Group>
    
        
      
        <Button onClick={(e)=>handleUpdate(e)} variant="primary" type="submit">
          Submit
        </Button>
      </Form>
   
  )

}
export default UpdateProfil
